import { memo } from 'react';
import { I18n } from 'src/modules/common/components/I18n/I18n';
import { MESSAGES } from 'src/modules/common/constants';

export const SafetyTooltipContent = memo(() => (
    <div className="vss-safety-tooltip-content">
        <p className="vss-safety-tooltip-content__text">
            <I18n messageId={MESSAGES.safetyDescription}/>
        </p>

        <ul className="vss-safety-tooltip-content__list">
            <li className="vss-safety-tooltip-content__row">
                <p className="vss-safety-tooltip-content__text">
                    <I18n messageId={MESSAGES.safetyVelocity}/>
                </p>
            </li>

            <li className="vss-safety-tooltip-content__row">
                <p className="vss-safety-tooltip-content__text">
                    <I18n messageId={MESSAGES.safetyCondition}/>
                </p>
            </li>

            <li className="vss-safety-tooltip-content__row">
                <p className="vss-safety-tooltip-content__text">
                    <I18n messageId={MESSAGES.safetySlug}/>
                </p>
            </li>
        </ul>

        <p className="vss-safety-tooltip-content__text">
            <I18n messageId={MESSAGES.safetyRecommendation}/>
        </p>
    </div>
));
